import axios from "axios";

const API = "https://naseebbilling.corealphaitsolutions.com/api/invoice";

export const addInvoice = async (data) => {
  return await axios.post(API, data);
};

export const getInvoices = async () => {
  return await axios.get(API);
};